import { useWhitelabel } from "hooks";
import usePayment from "hooks/usePayment";
import { useEffect, useMemo } from "react";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { sum } from "utils";
import { EnumStages } from "views/Partner/types";

export function usePaymentNavigation({ route, stage }: { route: string; stage: EnumStages }) {
  const [searchParams] = useSearchParams();
  
  const { dataPaymentBillet, dataTransferBank, paymentMethods } = usePayment();
  const { userIdWhitelabel } = useWhitelabel();
  const navigate = useNavigate();

  const sumBillets = useMemo(() => {
    const amountBillets =
      dataPaymentBillet?.billets?.map((billet) => billet.amount.total) ?? [];

    const amountDebits =
      dataPaymentBillet?.debits?.map((debit) => debit.amount) ?? [];

    const amountPix =
      dataPaymentBillet?.pix?.map((pix) => pix.amount.total) ?? [];

    const amountTransfers = dataTransferBank?.amount ?? 0;

    return Number(
      sum([
        ...amountBillets,
        ...amountDebits,
        ...amountPix,
        amountTransfers,
      ]).toFixed(2)
    );
  }, [dataPaymentBillet, dataTransferBank]);

  useEffect(() => {
    const newRoute = userIdWhitelabel
      ? `/${route}/${userIdWhitelabel}`
      : `/${route}`;

    if (sumBillets === 0) {
      navigate(
        {
          pathname: newRoute,
          search: `?${createSearchParams(searchParams)}`,
        },
        { state: { stage: EnumStages.SEARCH } }
      );
    }

    if (stage === EnumStages.SUMMARY && !paymentMethods.length) {
      navigate(
        {
          pathname: newRoute,
          search: `?${createSearchParams(searchParams)}`,
        },
        { state: { stage: EnumStages.PAYMENT_FORM } }
      );
    }
  }, [sumBillets, stage, userIdWhitelabel, route, navigate, searchParams]);


  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const confirmationMessage = "Tem certeza que deseja sair?";
      event.preventDefault();
      event.returnValue = confirmationMessage;
      return confirmationMessage;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return sumBillets;
}
